wbApp.filter('errorIndicator', [function () {
    return function (input) {
        if (!!input) {
            return "<i class='fa fa-exclamation-circle text-danger' aria-hidden='true' title='" + input + "'></i>"
        }

        return "";
    };
}]);


wbApp.filter('noteIndicator', [function () {
    return function (input) {
        if (!!input) {
            return "<i class='fa fa-question-circle text-success' aria-hidden='true' title='" + input + "'></i>"
        }

        return "";
    };
}]);